(ns pfo.widget.list (:require [pfo.util :as util]
                              [pfo.util :refer [split-string] :rename {split-string split}]))

(defn orderer [order-state label field]
  (let [parts (split @order-state #"-" 2)
        desc (= 2 (count parts))
        field-name (if desc (last parts) (first parts))
        is-current (= field field-name)]

    [:a {:href "#"
         :on-click (util/handler #(reset! order-state (if is-current
                                                        (if desc field (str "-" field))
                                                        field)))}
     label
     (when is-current
       (if desc " ▼ "  " ▲ "))]))
